import { User } from './../models/user.model';
import { Injectable, Injector } from '@angular/core';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { AppApiInterface } from 'src/app/app.api';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class UsersService  extends BaseService<User>{

    constructor(
        injector: Injector
    ) { 
        super(injector)
        this.copyJsonDataToObjectFunction=User.fromJsonToObject
        this.urls={
            getAllUrl:'users',
            saveUrl:'regUser',
            updateUrl:'up-user',
            deleteUrl:'dst-user',
            updateImageWithNoDataUrl:'up-usuario-imagem'
        }
    }

}